var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-modal"},[_c('auth-info-modal',{ref:"infoModal",on:{"next":_vm.showProjectModal}}),_c('auth-project-modal',{ref:"projectModal",on:{"submit":_vm.submit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }